module.exports = __webpack_public_path__ + "media/images/admin/icons/bookmark-4b8439822949fc7b58ef454d9500b3a4.svg";